import { d as t } from "./index795.mjs";
import "./index762.mjs";
import { c as p } from "./index808.mjs";
import { __exports as a } from "./index765.mjs";
var i = t, c = a, n = p, P = i ? function(r, e, o) {
  return c.f(r, e, n(1, o));
} : function(r, e, o) {
  return r[e] = o, r;
};
export {
  P as c
};
